(() => {
  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  const template = document.getElementById('MainContent')?.dataset.template;
  const allKits = template === 'collection'
    && /\/collections\/all-paint-by-numbers\/?$/.test(location.pathname);
  // Also load this asset behind the Liquid locale + ordinary-template gate.
  if (!['de', 'fr', 'es'].includes(locale) || !(template === 'product' || allKits)) return;

  const mount = () => {
    const host = document.querySelector('shopify-forms-embed#app-embed-container-1132855');
    const root = host?.shadowRoot;
    if (!root || root.querySelector('style[data-dam-eu-coupon-clearance]')) return;
    const style = document.createElement('style');
    style.dataset.damEuCouponClearance = '';
    // Target only this form's rotated teaser, never the host or a dialog/form step.
    style.textContent = '@media (max-width:760px){#app-embed[data-layout="overlay"][data-current-step="tease"][data-position="right-middle-rotated"]{display:none!important}}';
    root.append(style);
  };

  // Forms can arrive after the theme, or replace its host during an app rerender.
  const observer = new MutationObserver(mount);
  const observe = () => observer.observe(document.body, { childList: true, subtree: true });
  observe();
  customElements.whenDefined('shopify-forms-embed').then(mount);
  mount();
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    observe();
    mount();
  });
})();
